function changeText(){
    let formBilling = document.querySelector('[data-create-company-billing-form]');
    let formAddress = document.querySelector('[data-create-address]');
    if (formBilling || formAddress) {
        let createBtn = document.querySelector('.company-create-btn');
        let createAddress = document.querySelector('[data-create-addresses]');
        if (formBilling.querySelector('input[name="nip"]').value) {
            createBtn.value = 'Edytuj dane do faktury';
        } else {
            createBtn.value = 'Dodaj dane do faktury';
        }
    }
}


function popupShow(id){
    document.querySelector("#" + id).classList.add('show');
    document.querySelector('body').classList.add('no-overflow');
    changeText();
    if (id === 'animalImages') {
        document.querySelector('body').classList.add('overlay');
    }
    let background = document.querySelector('.address-bg');
    if (background) {
        background.classList.add('show');
    }
}

function popupHide(id){
    document.querySelector('#' + id).classList.remove('show');
    document.querySelector('body').classList.remove('no-overflow');
    document.querySelector('body').classList.remove('overlay');
    // if (id === 'animalImages') {
    //     document.querySelector('[data-animal-type].chosen').classList.remove('chosen');
    // }
    let background = document.querySelector('.address-bg');
    if (background) {
        background.classList.remove('show');
    }
}

function init(){
    let popupToggleButtons = document.querySelectorAll('[data-popup-toggle]'),
        popupCloseButtons = document.querySelectorAll('[data-popup-close]'),
        popupID = '';

    popupToggleButtons.forEach((button) => {

        button.addEventListener('click', () => {
            popupID = button.getAttribute('data-popup-toggle');
            popupShow(popupID);

        });
    });

    popupCloseButtons.forEach((button) => {

        button.addEventListener('click', () => {

            popupHide(popupID);

        });
    });
}

export default {init, popupHide};



// WEBPACK FOOTER //
// ./src/scripts/popup.js